//** Constant User Internal */
export const LIST_USER_INTERNAL_REQUEST = 'LIST_USER_INTERNAL_REQUEST'
export const LIST_USER_INTERNAL_SUCCESS = 'LIST_USER_INTERNAL_SUCCESS'
export const LIST_USER_INTERNAL_FAIL = 'LIST_USER_INTERNAL_FAIL'

export const LIST_USER_INTERNAL_SUMMARY_REQUEST = 'LIST_USER_INTERNAL_SUMMARY_REQUEST'
export const LIST_USER_INTERNAL_SUMMARY_SUCCESS = 'LIST_USER_INTERNAL_SUMMARY_SUCCESS'
export const LIST_USER_INTERNAL_SUMMARY_FAIL = 'LIST_USER_INTERNAL_SUMMARY_FAIL'

export const CREATE_USER_INTERNAL_REQUEST = 'CREATE_USER_INTERNAL_REQUEST'
export const CREATE_USER_INTERNAL_SUCCESS = 'CREATE_USER_INTERNAL_SUCCESS'
export const CREATE_USER_INTERNAL_FAIL = 'CREATE_USER_INTERNAL_FAIL'

export const DETAIL_USER_INTERNAL_REQUEST = 'DETAIL_USER_INTERNAL_REQUEST'
export const DETAIL_USER_INTERNAL_SUCCESS = 'DETAIL_USER_INTERNAL_SUCCESS'
export const DETAIL_USER_INTERNAL_FAIL = 'DETAIL_USER_INTERNAL_FAIL'

export const UPDATE_USER_INTERNAL_REQUEST = 'UPDATE_USER_INTERNAL_REQUEST'
export const UPDATE_USER_INTERNAL_SUCCESS = 'UPDATE_USER_INTERNAL_SUCCESS'
export const UPDATE_USER_INTERNAL_FAIL = 'UPDATE_USER_INTERNAL_FAIL'

export const UPDATE_PASSWORD_USER_INTERNAL_REQUEST = 'UPDATE_PASSWORD_USER_INTERNAL_REQUEST'
export const UPDATE_PASSWORD_USER_INTERNAL_SUCCESS = 'UPDATE_PASSWORD_USER_INTERNAL_SUCCESS'
export const UPDATE_PASSWORD_USER_INTERNAL_FAIL = 'UPDATE_PASSWORD_USER_INTERNAL_FAIL'

export const DELETE_USER_INTERNAL_REQUEST = 'DELETE_USER_INTERNAL_REQUEST'
export const DELETE_USER_INTERNAL_SUCCESS = 'DELETE_USER_INTERNAL_SUCCESS'
export const DELETE_USER_INTERNAL_FAIL = 'DELETE_USER_INTERNAL_FAIL'

export const LIST_USER_INTERNAL_BRANCH_REQUEST = 'LIST_USER_INTERNAL_BRANCH_REQUEST'
export const LIST_USER_INTERNAL_BRANCH_SUCCESS = 'LIST_USER_INTERNAL_BRANCH_SUCCESS'
export const LIST_USER_INTERNAL_BRANCH_FAIL = 'LIST_USER_INTERNAL_BRANCH_FAIL'

export const SET_MAIN_USER_INTERNAL_BRANCH_REQUEST = 'SET_MAIN_USER_INTERNAL_BRANCH_REQUEST'
export const SET_MAIN_USER_INTERNAL_BRANCH_SUCCESS = 'SET_MAIN_USER_INTERNAL_BRANCH_SUCCESS'
export const SET_MAIN_USER_INTERNAL_BRANCH_FAIL = 'SET_MAIN_USER_INTERNAL_BRANCH_FAIL'

export const USER_INTERNAL_RESET = 'USER_INTERNAL_RESET'
//** end section */

//** Constant User Partner */
export const LIST_USER_PARTNER_REQUEST = 'LIST_USER_PARTNER_REQUEST'
export const LIST_USER_PARTNER_SUCCESS = 'LIST_USER_PARTNER_SUCCESS'
export const LIST_USER_PARTNER_FAIL = 'LIST_USER_PARTNER_FAIL'

export const CREATE_USER_PARTNER_REQUEST = 'CREATE_USER_PARTNER_REQUEST'
export const CREATE_USER_PARTNER_SUCCESS = 'CREATE_USER_PARTNER_SUCCESS'
export const CREATE_USER_PARTNER_FAIL = 'CREATE_USER_PARTNER_FAIL'

export const DETAIL_USER_PARTNER_REQUEST = 'DETAIL_USER_PARTNER_REQUEST'
export const DETAIL_USER_PARTNER_SUCCESS = 'DETAIL_USER_PARTNER_SUCCESS'
export const DETAIL_USER_PARTNER_FAIL = 'DETAIL_USER_PARTNER_FAIL'

export const UPDATE_USER_PARTNER_REQUEST = 'UPDATE_USER_PARTNER_REQUEST'
export const UPDATE_USER_PARTNER_SUCCESS = 'UPDATE_USER_PARTNER_SUCCESS'
export const UPDATE_USER_PARTNER_FAIL = 'UPDATE_USER_PARTNER_FAIL'

export const DELETE_USER_PARTNER_REQUEST = 'DELETE_USER_PARTNER_REQUEST'
export const DELETE_USER_PARTNER_SUCCESS = 'DELETE_USER_PARTNER_SUCCESS'
export const DELETE_USER_PARTNER_FAIL = 'DELETE_USER_PARTNER_FAIL'

export const USER_PARTNER_RESET = 'USER_PARTNER_RESET'
//** end section */

//** Constant User Client */
export const LIST_USER_CLIENT_REQUEST = 'LIST_USER_CLIENT_REQUEST'
export const LIST_USER_CLIENT_SUCCESS = 'LIST_USER_CLIENT_SUCCESS'
export const LIST_USER_CLIENT_FAIL = 'LIST_USER_CLIENT_FAIL'

export const CREATE_USER_CLIENT_REQUEST = 'CREATE_USER_CLIENT_REQUEST'
export const CREATE_USER_CLIENT_SUCCESS = 'CREATE_USER_CLIENT_SUCCESS'
export const CREATE_USER_CLIENT_FAIL = 'CREATE_USER_CLIENT_FAIL'

export const DETAIL_USER_CLIENT_REQUEST = 'DETAIL_USER_CLIENT_REQUEST'
export const DETAIL_USER_CLIENT_SUCCESS = 'DETAIL_USER_CLIENT_SUCCESS'
export const DETAIL_USER_CLIENT_FAIL = 'DETAIL_USER_CLIENT_FAIL'

export const UPDATE_USER_CLIENT_REQUEST = 'UPDATE_USER_CLIENT_REQUEST'
export const UPDATE_USER_CLIENT_SUCCESS = 'UPDATE_USER_CLIENT_SUCCESS'
export const UPDATE_USER_CLIENT_FAIL = 'UPDATE_USER_CLIENT_FAIL'

export const DELETE_USER_CLIENT_REQUEST = 'DELETE_USER_CLIENT_REQUEST'
export const DELETE_USER_CLIENT_SUCCESS = 'DELETE_USER_CLIENT_SUCCESS'
export const DELETE_USER_CLIENT_FAIL = 'DELETE_USER_CLIENT_FAIL'

export const USER_CLIENT_RESET = 'USER_CLIENT_RESET'
//** end section */

export const LIST_MEMBERSHIP_USER_REQUEST = 'LIST_MEMBERSHIP_USER_REQUEST'
export const LIST_MEMBERSHIP_USER_SUCCESS = 'LIST_MEMBERSHIP_USER_SUCCESS'
export const LIST_MEMBERSHIP_USER_FAIL = 'LIST_MEMBERSHIP_USER_FAIL'

export const DELETE_MEMBERSHIP_USER_REQUEST = 'DELETE_MEMBERSHIP_USER_REQUEST'
export const DELETE_MEMBERSHIP_USER_SUCCESS = 'DELETE_MEMBERSHIP_USER_SUCCESS'
export const DELETE_MEMBERSHIP_USER_FAIL = 'DELETE_MEMBERSHIP_USER_FAIL'

export const VIEW_CARD_MEMBERSHIP_REQUEST = 'VIEW_CARD_MEMBERSHIP_REQUEST'
export const VIEW_CARD_MEMBERSHIP_SUCCESS = 'VIEW_CARD_MEMBERSHIP_SUCCESS'
export const VIEW_CARD_MEMBERSHIP_FAIL = 'VIEW_CARD_MEMBERSHIP_FAIL'

export const DETAIL_MEMBERSHIP_REQUEST = 'DETAIL_MEMBERSHIP_REQUEST'
export const DETAIL_MEMBERSHIP_SUCCESS = 'DETAIL_MEMBERSHIP_SUCCESS'
export const DETAIL_MEMBERSHIP_FAIL = 'DETAIL_MEMBERSHIP_FAIL'

export const RESET_DETAIL_MEMBERSHIP_REQUEST = 'RESET_DETAIL_MEMBERSHIP_REQUEST'

export const CREATE_MEMBERSHIP_REQUEST = 'CREATE_MEMBERSHIP_REQUEST'
export const CREATE_MEMBERSHIP_SUCCESS = 'CREATE_MEMBERSHIP_SUCCESS'
export const CREATE_MEMBERSHIP_FAIL = 'CREATE_MEMBERSHIP_FAIL'